(function () {
  var SEL = '.shopify-block[id*="qikify"] .bcontact-trigger-button';
  function paint(btn, active) {
    btn.style.setProperty('background-color', active ? '#1D4E4F' : 'transparent', 'important');
    btn.style.setProperty('color', active ? '#FCFAF8' : '#1D4E4F', 'important');
  }
  function styleButtons() {
    document.querySelectorAll(SEL).forEach(function (btn) {
      if (btn.dataset.ejStyled) return;
      btn.dataset.ejStyled = '1';
      paint(btn, false);
      ['mouseenter', 'focus'].forEach(function (e) { btn.addEventListener(e, function () { paint(btn, true); }); });
      ['mouseleave', 'blur'].forEach(function (e) { btn.addEventListener(e, function () { paint(btn, false); }); });
    });
  }
  styleButtons();
  new MutationObserver(styleButtons).observe(document.body, { childList: true, subtree: true });
})();